/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  // Desktop search: sync summary input with popdown field when user types.
  // Do not auto-open search on load — that triggered body scroll-lock on mobile.
  const searchInputField = document.getElementById('custom_search_input');
  const displayField = document.getElementById('SearchInput--desktop');
  const searchIcon = document.querySelector('.custom_search-bar');

  if (!searchInputField || !displayField || !searchIcon) {
    return;
  }

  let firstKeyPending = true;

  searchInputField.addEventListener('keydown', function (e) {
    if (e.key === 'Backspace' || e.ctrlKey || e.metaKey || e.altKey) {
      return;
    }
    if (firstKeyPending && e.key.length === 1) {
      displayField.value += e.key;
      searchIcon.click();
      firstKeyPending = false;
    }
  });

  displayField.addEventListener('keydown', function () {
    searchInputField.value = displayField.value;
    firstKeyPending = true;
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
